import { Product } from "@/types/entities";
import { log } from "@/utils/logger";
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useUser } from "@/context/user";
import { useTable } from "@/context/table";
import { isDefined } from "@/utils/validations";
import storage from "@/utils/storage";
import api from "@/config/api";

const useQueryProducts = () => {
    const authenticated = useUser(state => state.authenticated);
    const oid = storage.getItem("oid");
    const bid = storage.getItem("bid");

    const enabled = authenticated && isDefined(bid) && isDefined(oid);

    const { filterModel, paginationModel, sortModel } = useTable();

    const { pageSize, page } = paginationModel;
    const { field, sort } = sortModel;
    // const { search } = filters;

    const getProducts = async () => {
        try {
            const endpoint = `/organizations/${oid}/brands/${bid}/products?page=${page}&pageSize=${pageSize}&sortField=${field}&sortDirection=${sort}`;

            // if (search) endpoint += `&search=${search}`;

            const data = await api.get<Product[]>(endpoint);
            return data;
        } catch (e) {
            log.error(e, "getProducts");
        }
    };

    return useQuery({
        queryKey: ["products", bid, page, filterModel, sortModel],
        queryFn: getProducts,
        enabled,
        placeholderData: keepPreviousData,
        staleTime: Infinity,
    });
};

export default useQueryProducts;
